'use client';

import {getCurrentGameCookieName, GAME_SETTINGS_LS_NAME} from '@/utils/constant';
import {SDKSettings} from '@/app/(app)/sdk/[gid]/types';
import Cookies from 'js-cookie';
import {parseSettingsCookie} from '@/services/internal/settings/index';
import getGameId from '@/utils/getGameId';

export const getStoredSettingsCookie = () => {
  if (typeof window === 'undefined') {
    console.warn('This should be used client-side only');
    return null;
  }
  const gameId = getGameId();
  return parseSettingsCookie(Cookies.get(getCurrentGameCookieName(gameId)));
};

const getStoredGameId = () => getStoredSettingsCookie()?.gid || null;

export const getStoredSettings = () => {
  if (typeof window === 'undefined') {
    console.warn('This should be used client-side only');
    return null;
  }

  const gid = getStoredGameId();

  if (!gid) {
    return null;
  }

  const localStorage = window.localStorage.getItem(`${GAME_SETTINGS_LS_NAME}${gid}`);
  if (!localStorage) {
    return null;
  }

  try {
    const settings = JSON.parse(localStorage) as SDKSettings | undefined;

    if (!settings || String(settings.gameInfo.id) !== gid) {
      window.localStorage.removeItem(`${GAME_SETTINGS_LS_NAME}${gid}`);
      return null;
    }

    return settings;
  } catch (e) {
    return null;
  }
};

export const areSettingsAvailable = (gid?: string) => {
  const cookie = getStoredSettingsCookie();
  const settings = getStoredSettings();

  if (!cookie || !settings) {
    return false;
  }

  if (typeof gid !== 'undefined') {
    return String(cookie.gid) === String(gid) && String(settings.gameInfo.id) == String(gid);
  }

  return String(cookie.gid) == String(settings.gameInfo.id);
};
